<template>
  <div class="container mb-5">
    <h1 class="py-4">仕事登録</h1>
    <div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-disp-status">表示ステータス *</label>
        <div class="col-sm-10">
          <select id="l-disp-status" class="form-control" v-model="dispStatus">
            <option v-for="(value, index) in this.jobValues.dispStatus" :key="index" :value="value.code">
              {{ value.label }}
            </option> 
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-summary">仕事概要 *</label>
        <div class="col-sm-10">
          <input id="l-summary" class="form-control" type="text" v-model="summary">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-apply-url">申込URL *</label>
        <div class="col-sm-10">
          <input id="l-apply-url" class="form-control" type="text" v-model="applyUrl">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-pref-code">勤務地 *</label>
        <div class="col-sm-10">
          <select id="l-pref-code" class="form-control" v-model="prefCode">
            <option disabled value="">選択してください</option>
            <option v-for="(value, index) in this.prefs" :key="index" :value="value.code">
              {{ value.name }}
            </option> 
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-salary-f">給与 FROM *</label>
        <div class="col-sm-10">
          <input id="l-salary-f" class="form-control" type="number" v-model="salaryF">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-salary-t">給与 TO</label>
        <div class="col-sm-10">
          <input id="l-salary-t" class="form-control" type="number" v-model="salaryT">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-japlevel">日本語レベル *</label>
        <div class="col-sm-10">
          <select id="l-japlevel" class="form-control" v-model="japlevel">
            <option disabled value="">選択してください</option>
            <option v-for="(value, index) in this.langLevels" :key="index" :value="value.code">
              {{ value.level }}
            </option> 
          </select>
        </div>
      </div>
      <br>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-hour1-f">勤務時間1 FROM *</label>
        <div class="col-sm-10">
          <input id="l-hour1-f" class="form-control" type="text" v-model="hour1F">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-hour1-t">勤務時間1 TO *</label>
        <div class="col-sm-10">
          <input id="l-hour1-t" class="form-control" type="text" v-model="hour1T">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-hour1-w">勤務時間1 文言</label>
        <div class="col-sm-10">
          <input id="l-hour1-w" class="form-control" type="text" v-model="hour1W">
        </div>
      </div>
      <br>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-hour2-f">勤務時間2 FROM</label>
        <div class="col-sm-10">
          <input id="l-hour2-f" class="form-control" type="text" v-model="hour2F">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-hour2-t">勤務時間2 TO</label>
        <div class="col-sm-10">
          <input id="l-hour2-t" class="form-control" type="text" v-model="hour2T">
        </div>  
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-hour2-w">勤務時間2 文言</label>
        <div class="col-sm-10">
          <input id="l-hour2-w" class="form-control" type="text" v-model="hour2W">
        </div>
      </div>
      <br>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-hour3-f">勤務時間3 FROM</label>
        <div class="col-sm-10">
          <input id="l-hour3-f" class="form-control" type="text" v-model="hour3F">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-hour3-t">勤務時間3 TO</label>
        <div class="col-sm-10">
          <input id="l-hour3-t" class="form-control" type="text" v-model="hour3T">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-hour3-w">勤務時間3 文言</label>
        <div class="col-sm-10">
          <input id="l-hour3-w" class="form-control" type="text" v-model="hour3W">
        </div>
      </div>
      <br>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-near-sta1">最寄駅1</label>
        <div class="col-sm-10">
          <input id="l-near-sta1" class="form-control" type="text" v-model="nearSta1">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-near-sta1-w">最寄駅1 文言</label>
        <div class="col-sm-10">
          <input id="l-near-sta1-w" class="form-control" type="text" v-model="nearSta1W">
        </div>
      </div>
      <br>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-near-sta2">最寄駅2</label>
        <div class="col-sm-10">
          <input id="l-near-sta2" class="form-control" type="text" v-model="nearSta2">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-near-sta2-w">最寄駅2 文言</label>
        <div class="col-sm-10">
          <input id="l-near-sta2-w" class="form-control" type="text" v-model="nearSta2W">
        </div>
      </div>
      <br>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-near-sta3">最寄駅3</label>
        <div class="col-sm-10">
          <input id="l-near-sta3" class="form-control" type="text" v-model="nearSta3">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-near-sta3-w">最寄駅3 文言</label>
        <div class="col-sm-10">
          <input id="l-near-sta3-w" class="form-control" type="text" v-model="nearSta3W">
        </div>
      </div>
      <br>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-other">その他条件/PR</label>
        <div class="col-sm-10">
          <textarea class="form-control" id="l-other" v-model="other">Javaカリキュラム</textarea>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-2 col-form-label" for="l-emp-type">雇用形態 *</label>
        <div class="col-sm-10">
          <input id="l-emp-type" class="form-control" type="text" v-model="empType" disabled>
        </div>
      </div>
      <div class="alert alert-danger my-5" role="alert" v-if="this.error && errorItem">
        {{ errorItem }} は必須項目です。
      </div>
      <div class="text-right">
        <button class="btn btn-primary" @click="register">登録</button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import utils from '@/utils/Utils'
import master from '@/constants/MasterEnum'

export default {
  name :"RegisterJob",
  mixins: [
    utils,
    master
  ],
  data() {
    return {
      db : firebase.firestore(),
      dispStatus : 0,
      summary : "",
      applyUrl : "",
      prefCode : "",
      salaryF: "",
      salaryT : "",
      japlevel : "",
      hour1F : "",
      hour1T : "",
      hour1W : "",
      hour2F : "",
      hour2T : "",
      hour2W : "",
      hour3F : "",
      hour3T : "",
      hour3W : "",
      nearSta1 : "",
      nearSta1W : "",
      nearSta2 : "",
      nearSta2W : "",
      nearSta3 : "",
      nearSta3W : "",
      other : "",
      empType : "パートアルバイト",
      error : false,
    }
  },
  computed : {
    errorItem : function() {
      var item = "";
      const data = this;
      this.jobValues.required.forEach(elem => {
        if(this.isEmpty(data[elem.key])) {
          item += elem.label + ", ";
        }
      });
      return item;
    }  
  },
  methods: {
    changeOther: function(event) {
        this.other = event.target.value
    },
    /**
     * エラーチェックメソッド
     * @returns エラーがあったらtrue
     */
    validate: function() {
      this.error = false;
      this.jobValues.required.forEach(elem => {
        if(this.isEmpty(this[elem.key])) {
          this.error = true;
          return;
        }
      })
    },
    register : function() {
      this.validate();
      if (this.error) {
        this.$toasted.error("必須項目に不足があります")
      }
      else {
        const date = firebase.firestore.FieldValue.serverTimestamp();
        this.db.collection("jobs")
          .add({
            display_status : this.dispStatus,
            summary : this.summary,
            apply_url : this.applyUrl,
            pref_code : this.prefCode,
            salary_from : this.salaryF,
            salary_to : this.salaryT,
            japanese_level_code: this.japlevel,
            working_hours1_from : this.hour1F,
            working_hours1_to : this.hour1T,
            working_hours1_word : this.hour1W,
            working_hours2_from : this.hour2F,
            working_hours2_to : this.hour2T,
            working_hours2_word : this.hour2W,
            working_hours3_from : this.hour3F,
            working_hours3_to : this.hour3T,
            working_hours3_word : this.hour3W,
            nearrest_station1 : this.nearSta1,
            nearrest_station1_word : this.nearSta1W,
            nearrest_station2 : this.nearSta2,
            nearrest_station2_word : this.nearSta2W,
            nearrest_station3 : this.nearSta3,
            nearrest_station3_word : this.nearSta3W,
            other : this.other,
            employment_type_name : this.empType,
            created_at : date,
            updated_at : date
        })
        .then((doc) => {
          this.$toasted.success("登録しました")
          this.$router.push({ name: 'Job', params: { id: doc.id } })
        })
        .catch(() => {
          this.$toasted.error("登録に失敗しました")
        });
      }
    }
  },
}



</script>